@if (form) {
  <rask-container-block [formGroup]="form">
    <div class="row">
      <h4>Förhindra ändring av följande egenskaper i maskinen:</h4>
    </div>
    <div class="row">
      <rask-checkbox class="col-2" text="Apteringsvillkor" formControlName="apteringsvillkor"></rask-checkbox>
      <rask-checkbox class="col-2" text="Begränsningsinställningar" formControlName="begransningsinstallningar"></rask-checkbox>
    </div>
    <div class="row">
      <rask-checkbox class="col-2" text="Begränsningsmatris" formControlName="begransningsmatris"></rask-checkbox>
      <rask-checkbox class="col-2" text="Diameterinställningar" formControlName="diameterinstallningar"></rask-checkbox>
    </div>
    <div class="row">
      <rask-checkbox class="col-2" text="Färgmarkning" formControlName="fargmarkning"></rask-checkbox>
      <rask-checkbox class="col-2" text="Fördelningsinställningar" formControlName="fordelningsinstallningar"></rask-checkbox>
    </div>
    <div class="row">
      <rask-checkbox class="col-2" text="Fördelningsmatris" formControlName="fordelningsmatris"></rask-checkbox>
      <rask-checkbox class="col-2" text="Kapfönster" formControlName="kapfonster"></rask-checkbox>
    </div>
    <div class="row">
      <rask-checkbox class="col-2" text="Kvalitetsinställningar" formControlName="kvalitetsinstallningar"></rask-checkbox>
      <rask-checkbox class="col-2" text="Längdinställningar" formControlName="langdinstallningar"></rask-checkbox>
    </div>
    <div class="row">
      <rask-checkbox class="col-2" text="Prisinställningar" formControlName="prisinstallningar"></rask-checkbox>
      <rask-checkbox class="col-2" text="Värdematris" formControlName="vardematris"></rask-checkbox>
    </div>
  </rask-container-block>
}

